
// SVG Icon: splitterOn
export default { id: "terriajs-splitterOn" };
export const id = "terriajs-splitterOn";
export const name = "splitterOn";
